import { UNIT_SYSTEM } from "../constants/UnitConsts"

export default class PlayerUser {
  constructor({
    firstName = "",
    middleName = "",
    lastName = "",
    email = "",
    beltNumber = "",
    dateOfBirth = "",
    parentFirstName = "",
    parentLastName = "",
    phone = "",
    height = "",
    weight = "",
    parentPhone = "",
    parentEmail = "",
    file = "",
    termsAndPolicyConfirmed = false,
    legalGuardianConfirmed = false,
    lockedParent = false,
    unitDistance = UNIT_SYSTEM.METRIC,
    unitHeightWeight = UNIT_SYSTEM.METRIC,
  } = {}) {
    this.firstName = firstName
    this.middleName = middleName
    this.lastName = lastName
    this.email = email
    this.beltNumber = beltNumber
    this.dateOfBirth = dateOfBirth
    this.parentFirstName = parentFirstName
    this.parentLastName = parentLastName
    this.phone = phone
    this.height = height
    this.weight = weight
    this.parentPhone = parentPhone
    this.parentEmail = parentEmail
    this.file = file
    this.termsAndPolicyConfirmed = termsAndPolicyConfirmed
    this.legalGuardianConfirmed = legalGuardianConfirmed
    this.lockedParent = lockedParent
    this.unitDistance = unitDistance
    this.unitHeightWeight = unitHeightWeight
  }

  validationRules() {
    return {
      firstName: "required|max:32",
      middleName: "max:32",
      lastName: "required|max:32",
      password: "required|min:8",
      confirmPassword: "required|confirmed:password",
      email: "required|email",
      beltNumber: "max:15|numeric",
      phone: "max:12|numeric",
      parentPhone: "max:12",
      parentEmail: "required|email",
      height: "between:90,305|numeric|required",
      weight: "between:15,200|decimal:1"
    }
  }
}
